{
  "name": "scribbly-admin-front",
  "version": "0.2.124",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve -c local",
    "start:staging": "ng serve -c staging",
    "build": "ng build",
    "build:staging": "ng build --configuration staging",
    "build:development": "ng build --configuration development",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.0",
    "@angular/cdk": "~17.3.10",
    "@angular/common": "^17.3.0",
    "@angular/compiler": "^17.3.0",
    "@angular/core": "^17.3.0",
    "@angular/forms": "^17.3.0",
    "@angular/material": "~17.3.10",
    "@angular/platform-browser": "^17.3.0",
    "@angular/platform-browser-dynamic": "^17.3.0",
    "@angular/router": "^17.3.0",
    "@ngneat/until-destroy": "^10.0.0",
    "@ngrx/effects": "^17.2.0",
    "@ngrx/entity": "^17.2.0",
    "@ngrx/store": "^17.2.0",
    "@ngrx/store-devtools": "^17.2.0",
    "@rx-angular/template": "^17.3.1",
    "@types/swiper": "^5.4.3",
    "@wlcm/angular": "^17.7.32",
    "@wlcm/common": "^1.0.2",
    "angular-svg-icon": "^17.0.0",
    "cropperjs": "^2.1.0",
    "murmurhash": "^2.0.1",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-socket-io": "^4.6.1",
    "rxjs": "~7.8.0",
    "swiper": "^11.1.15",
    "tslib": "^2.3.0",
    "uuid": "^11.0.3",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.0",
    "@angular/cli": "^17.3.0",
    "@angular/compiler-cli": "^17.3.0",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "3.3",
    "typescript": "~5.4.2"
  },
  "packageManager": "yarn@1.22.19+sha1.4ba7fc5c6e704fce2066ecbfb0b0d8976fe62447"
}
